import { Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'

export const InputText = ({
  name,
  control,
  label,
  required = false,
  textArea = false,
  isEmail = false,
  maxLength,
  inputType = 'text',
}) => {
  return (
    <Controller
      rules={{
        required: required ? 'Ce champ est obligatoire' : false,
        maxLength: maxLength
          ? {
              value: maxLength,
              message: `Le texte ne doit pas dépasser ${maxLength} caractères`,
            }
          : null,
        pattern: isEmail
          ? {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "L'adresse e-mail n'est pas correcte",
            }
          : null,
      }}
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          helperText={error ? error.message : null}
          error={!!error}
          onChange={onChange}
          value={value}
          fullWidth
          label={label}
          variant="outlined"
          sx={{ mb: 3 }}
          multiline={textArea}
          minRows={textArea ? 3 : 0}
          type={inputType}
        />
      )}
    />
  )
}
